import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment"

function Chart({series, interval, maxPrice}) {
  const options = {
    tooltip: {
      formatter: function() {
          const convertToRupiah = this.y.toLocaleString("id-ID")
          return `${moment(new Date(this.x)).format('MMM Do YY')}<br/><br/><b>IDR ${convertToRupiah}</b><br/>`
      },
      headerFormat: null
    },
    series: [
      {
        animation: {
          duration: 1000
        },
        data: series || [],
        type: "areaspline",
        threshold: [],
        color: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, "#1b9755"],
            [1, "#cce8da"]
          ]
        }
      }
    ],
    plotOptions: {
      areaspline: {
        lineColor: "#1b9755"
      },
    },
    navigator: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
    xAxis: {
      type: "datetime",
      labels: {
        format: "{value:%e/%m/%y}",
      },
      // tickInterval: 0,
      // tickPositions: series.length > 0 && [series[1][0], series[4][0], series[7][0], series[10][0], series[13][0], series[16][0], series[19][0]]
    },
    yAxis: {
      max: maxPrice,
      endOnTick: true,
      opposite: false,
      lineWidth: 1,
      tickWidth: 1,
      tickLength: 1,
      title: {
          align: 'high',
          offset: 0,
          rotation: 0,
          y: -12,
          x: 30,
          style: {
            fontSize: "1em",
            fontWeight: "bold"
          }
      },
      labels: {
        formatter: function() {
          return this.value / 1000000 + "M";
          // if (this.value >= 1E6) {
          //   return this.value / 1000000;
          // }
          // return this.value / 1000;
        },
        align: "left",
        x: 1,
        style: {
          fontSize: "1em",
        }
      },
    },
    rangeSelector: {enabled: false, inputEnabled: false}
  }

  return (
    <div>
      <HighchartsReact options={options} highcharts={Highcharts} constructorType={"stockChart"}/>
    </div>
  )
}

export default Chart
